import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setProvider} from '../../redux/actions/Web3';
import {logoutUser} from '../../redux/actions/Auth';
import {Web3Modal} from './Web3Modal';
import {showError} from '../../redux/actions';
import {BrowserProvider} from 'ethers';
import {UPDATE_TRANSACTIONS} from 'types/actions/Transaction.actions';

const Web3Provider: React.FC = () => {
  const auth = useSelector((state: any) => state.auth.user);
  const provider = useSelector((state: any) => state.web3.provider);

  const dispatch = useDispatch();

  useEffect(() => {
    const connectWeb3Modal = async () => {
      try {
        if (auth && !provider) {
          const web3ModalProvider = await Web3Modal.connect();

          const web3Provider = new BrowserProvider(web3ModalProvider);
          const signer = await web3Provider.getSigner();
          const walletAddress = await signer.getAddress();

          if (walletAddress.toLowerCase() !== auth.address.toLowerCase()) {
            dispatch(logoutUser());
            window.location.reload();
            return;
          }

          web3ModalProvider.on('accountsChanged', () => {
            dispatch(logoutUser());
            window.location.reload();
          });

          web3ModalProvider.on('chainChanged', () => {
            window.location.reload();
          });

          dispatch(setProvider(web3Provider));
          dispatch({type: UPDATE_TRANSACTIONS});
        }
      } catch (error) {
        dispatch(showError('Failed to connect to web3 modal'));
      }
    };

    connectWeb3Modal();
  }, [auth, provider, dispatch]);

  return null;
};

export default Web3Provider;
